/* Collection v2 (Romain 19/10: mix of proposals 1, 2, 5 and 6).
   - extras (coups de cœur, « Les plus aimées », « Vue chez vous », « Composez votre mur », end of page) fetched once after load from the
     section rv-coll-extras (Section Rendering API) and copied into the empty placeholders [data-cv2="key"], again after each AJAX filter swap;
   - « Vues récemment » from the visitor's own localStorage (rv-vues, written on product pages by rv-recent-track);
   - phones: « Prix en A4 A3 A2 A1 A0 » row in the sticky Filtrer / Trier bar, every card shows its real price in that format (data-fp);
   - phones: the bag button of a card opens a bottom sheet (formats with size, use and price, amount left for free delivery, 1 add button).
   Relies on window.RV (rv-core.js). Mouse devices keep the rv-v3 popover. */
(function () {
  "use strict";
  var coll = document.querySelector("[data-rv-coll][data-cv2-src]"); if (!coll) return;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
  var money = function (c) { return window.RV && RV.money ? RV.money(c) : (Number(c) / 100).toFixed(2); };
  var T = function (k, v) { return window.RV && RV.t ? RV.t(k, v) : k; };
  /* free shipping threshold of the visitor's zone; "0" = unknown in the visitor's currency (snippet rv-ship-zone): static line, no bar */
  var FREE = window.RV && RV.freeConv ? RV.freeConv : coll.getAttribute("data-cv2-free") === "0" ? 0 : Number(coll.getAttribute("data-cv2-free")) || 5900;
  var FROM = function () { return T("ship_js.from", { amount: window.RV && RV.freeShippingTxt }).replace(/<[^>]+>/g, ""); };
  var PACKS = coll.getAttribute("data-cv2-packs") === "1";
  var R3 = Number(coll.getAttribute("data-cv2-r3")) || 10, R4 = Number(coll.getAttribute("data-cv2-r4")) || 15;
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } }
  };

  /* ---------- extras ---------- */
  var parts = null, loading = null;
  var load = function () {
    if (loading) return loading;
    loading = fetch(coll.getAttribute("data-cv2-src"), { credentials: "same-origin" })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) {
        var d = new DOMParser().parseFromString(t, "text/html"); parts = {};
        $$("[data-cv2]", d).forEach(function (n) { parts[n.getAttribute("data-cv2")] = n; });
        fill();
      }).catch(function () { loading = null; });
    return loading;
  };
  var fill = function () {
    if (!parts) return;
    $$("[data-cv2]", coll).forEach(function (ph) {
      var k = ph.getAttribute("data-cv2"), src = parts[k];
      var empty = ph.hasAttribute("data-cv2-empty") || (ph.hidden && !ph.children.length);
      if (!empty) return;
      if (!src) return;
      var n = document.importNode(src, true); n.hidden = false; n.removeAttribute("data-cv2-empty");
      ph.replaceWith(n); arm(n);
    });
  };
  var arm = function (n) {
    if (window.RV && RV.scroller) $$("[data-rv-scroller]", n).forEach(function (el) { RV.scroller(el); });
    if (n.getAttribute("data-cv2") === "vc") armVc(n);
    if (n.getAttribute("data-cv2") === "pack") armPack(n);
    if (n.getAttribute("data-cv2") === "end") recent(n);
  };
  var later = function (fn) { if (window.requestIdleCallback) requestIdleCallback(fn, { timeout: 2500 }); else setTimeout(fn, 400); };
  var start = function () { later(load); };
  if (document.readyState === "complete") start(); else window.addEventListener("load", start);
  /* rv-lot1 replaces .rv-results after each filter / sort: put the rows back */
  if (window.MutationObserver) {
    var t = 0;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { fill(); applyFmt(); }, 60); })
      .observe(coll, { childList: true, subtree: true });
  }

  /* « Vue chez vous »: thumbnails switch the big wall photo */
  var armVc = function (n) {
    n.addEventListener("click", function (e) {
      var b = e.target.closest(".cv2-vc-th"); if (!b) return;
      $$(".cv2-vc-th", n).forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
      var ph = $(".cv2-vc-ph", n), img = $(".cv2-vc-ph img", n), bg = $(".cv2-vc-bg", n), fit = b.getAttribute("data-fit") || "cover";
      if (ph) ph.setAttribute("data-fit", fit);
      if (bg) bg.style.backgroundImage = fit === "contain" ? "url(" + b.getAttribute("data-bg") + ")" : "";
      if (img) { img.srcset = b.getAttribute("data-ms"); img.src = b.getAttribute("data-m"); img.alt = b.getAttribute("data-al") || ""; }
      $("[data-vc-t]", n).textContent = b.getAttribute("data-t");
      $("[data-vc-a]", n).src = b.getAttribute("data-a");
      $("[data-vc-p]", n).innerHTML = b.getAttribute("data-p");
      $$("[data-vc-link]", n).forEach(function (a) { a.href = b.getAttribute("data-u"); });
    });
  };

  /* « Vues récemment »: the visitor's own posters (max 4), hidden when there are none */
  var recent = function (n) {
    var box = $("[data-cv2-recent]", n), row = $("[data-cv2-recent-row]", n); if (!box || !row) return;
    var list = store.get("rv-vues", []); if (!Array.isArray(list)) list = [];
    list = list.filter(function (x) { return x && x.u && x.i && x.t; }).slice(0, 4);
    if (!list.length) { n.classList.add("cv2-no-recent"); return; }
    row.innerHTML = list.map(function (x) {
      return '<a class="cv2-mini" href="' + esc(x.u) + '"><span class="cv2-mini-ph"><img src="' + esc(x.i) + '" alt="' + esc(x.t) + '" loading="lazy" width="200" height="283"></span><span class="cv2-mini-t">' + esc(x.t.replace(/^Affiche\s+/i, "").replace(/^./, function (c) { return c.toUpperCase(); })) + '</span>' + (x.p ? '<span class="cv2-mini-p">' + T("coll_v2_js.from_price", { price: esc(x.p) }) + "</span>" : "") + "</a>";
    }).join("");
    box.hidden = false;
  };

  /* ---------- phones: prices in one format ---------- */
  var FKEY = "cv2-fmt";
  var curF = (function () { try { return sessionStorage.getItem(FKEY) || ""; } catch (e) { return ""; } })();
  var applyFmt = function () {
    $$(".cv2-fq [data-cv2-f]", coll).forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-cv2-f") === curF)); });
    $$(".wallcard[data-fp]", coll).forEach(function (c) {
      var sp = $(".info > span", c); if (!sp) return;
      if (!sp.hasAttribute("data-cv2-orig")) sp.setAttribute("data-cv2-orig", sp.innerHTML);
      if (!curF) { if (sp.getAttribute("data-cv2-on")) { sp.innerHTML = sp.getAttribute("data-cv2-orig"); sp.removeAttribute("data-cv2-on"); } return; }
      if (sp.getAttribute("data-cv2-on") === curF) return; /* already shown: no DOM write, so the observer stays quiet */
      var hit = null;
      c.getAttribute("data-fp").split(",").forEach(function (e) { var p = e.split(":"); if (p[0] === curF) hit = p; });
      if (!hit) { sp.innerHTML = '<span class="cv2-fna">' + T("coll_v2_js.size_unavailable", { size: curF }) + "</span>"; sp.setAttribute("data-cv2-on", curF); return; }
      var pr = Number(hit[1]), cp = Number(hit[2]) || 0;
      sp.innerHTML = curF + " · " + (cp > pr ? '<span class="off"><strong>' + money(pr) + "</strong></span> <s>" + money(cp) + "</s>" : "<strong>" + money(pr) + "</strong>");
      sp.setAttribute("data-cv2-on", curF);
    });
  };
  coll.addEventListener("click", function (e) {
    var b = e.target.closest(".cv2-fq [data-cv2-f]"); if (!b) return;
    var f = b.getAttribute("data-cv2-f"); curF = curF === f ? "" : f;
    try { sessionStorage.setItem(FKEY, curF); } catch (er) {}
    applyFmt();
  });
  if (curF) applyFmt();

  /* ---------- phones: bottom sheet « Ajouter au panier » ---------- */
  var DIM = { A4: [21, 29.7], A3: [29.7, 42], A2: [42, 59.4], A1: [59.4, 84.1], A0: [84.1, 118.9] }; /* real Gelato print sizes (ISO A) */
  var USE = { A4: T("coll_v2_js.use_a4"), A3: T("coll_v2_js.use_a3"), A2: T("coll_v2_js.use_a2"), A1: T("coll_v2_js.use_a1"), A0: T("coll_v2_js.use_a0") };
  var ORDER = ["A4", "A3", "A2", "A1", "A0"];
  var fmtOf = function (o) {
    o = String(o || "");
    var m = o.match(/^\s*(A[0-6])\b/i); if (m) return m[1].toUpperCase();
    var n = o.match(/([\d.]+)"\s*x\s*([\d.]+)"/);
    if (n) { var big = Math.max(parseFloat(n[1]), parseFloat(n[2])); return big <= 12 ? "A4" : big <= 17 ? "A3" : big <= 24 ? "A2" : big <= 34 ? "A1" : "A0"; }
    return "";
  };
  var cm = function (x) { return String(x).replace(".", T("coll_v2_js.decimal")); };
  var useSheet = function () { return window.matchMedia && (matchMedia("(hover: none), (pointer: coarse)").matches || innerWidth < 700); };
  var PJ = {};
  var getP = function (h) {
    if (!PJ[h]) PJ[h] = fetch((window.RV && RV.root ? RV.root.replace(/\/$/, "") : "") + "/products/" + encodeURIComponent(h) + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { if (!r.ok) throw r; return r.json(); }).catch(function (e) { delete PJ[h]; throw e; });
    return PJ[h];
  };
  var cartTotal = function () {
    return fetch((window.RV && RV.root ? RV.root.replace(/\/$/, "") : "") + "/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.json(); }).then(function (c) { return c.total_price || 0; }).catch(function () { return 0; });
  };
  var sh = null, shBtn = null, st = null;
  var build = function () {
    sh = document.createElement("div"); sh.className = "cv2-sheet"; sh.hidden = true;
    sh.innerHTML = '<div class="cv2-sh-in" role="dialog" aria-modal="true" aria-labelledby="cv2-sh-t"><span class="cv2-grab" aria-hidden="true"></span>' +
      '<div class="cv2-sh-top"><img data-sh-img alt="" width="56" height="78"><div><b id="cv2-sh-t" data-sh-t></b><small>' + T("coll_v2_js.sheet_sub") + '</small></div><button type="button" class="cv2-sh-x" data-sh-x aria-label="' + T("coll_v2_js.close") + '"><svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button></div>' +
      '<p class="cv2-sh-k" id="cv2-sh-k">' + T("coll_v2_js.choose_size") + '</p><div class="cv2-sh-fs" role="radiogroup" aria-labelledby="cv2-sh-k" data-sh-fs></div>' +
      '<div class="cv2-sh-ship"><i data-sh-bar></i><span data-sh-ship></span></div>' +
      '<button type="button" class="btn btn-main cv2-sh-add" data-sh-add>' + T("coll_v2_js.add_to_cart") + '</button>' +
      (PACKS ? '<p class="cv2-sh-pack">' + T("coll_v2_js.pack_hint", { r3: R3, r4: R4 }) + '</p>' : "") + "</div>";
    document.body.appendChild(sh);
    sh.addEventListener("click", function (e) {
      if (e.target === sh || e.target.closest("[data-sh-x]")) { close(true); return; }
      var o = e.target.closest(".cv2-sf"); if (o && !o.disabled) { st.v = o.getAttribute("data-v"); paint(); return; }
      if (e.target.closest("[data-sh-add]")) add();
    });
    sh.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { e.preventDefault(); close(true); return; }
      if (e.key === "Tab") { /* keep focus inside the sheet */
        var f = $$("button:not([disabled])", sh), a = document.activeElement;
        if (e.shiftKey && a === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && a === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
  };
  var paint = function () {
    var v = null;
    $$(".cv2-sf", sh).forEach(function (b) { var on = b.getAttribute("data-v") === st.v; b.setAttribute("aria-checked", String(on)); b.classList.toggle("on", on); });
    st.p.variants.forEach(function (x) { if (String(x.id) === st.v) v = x; });
    var add = $("[data-sh-add]", sh); add.disabled = !v;
    add.textContent = v ? T("coll_v2_js.add_to_cart_price", { price: money(v.price) }) : T("coll_v2_js.add_to_cart");
    /* audit 18/10: the projection is said as such (« avec cette affiche »), and an already free cart is said first */
    var left = FREE - st.total - (v ? v.price : 0);
    $("[data-sh-ship]", sh).textContent = !FREE ? FROM() : st.total >= FREE ? T("coll_v2_js.ship_already_free", { amount: (window.RV && RV.moneyShort ? RV.moneyShort(FREE) : money(FREE)) }) :
      left > 0 ? T("coll_v2_js.ship_left", { amount: money(left) }) : T("coll_v2_js.ship_will_be_free");
    $("[data-sh-bar]", sh).style.setProperty("--p", (FREE ? Math.max(4, Math.min(100, (st.total + (v ? v.price : 0)) / FREE * 100)) : 0) + "%");
    $(".cv2-sh-ship", sh).classList.toggle("is-free", !!FREE && left <= 0);
  };
  var open = function (btn, p, total) {
    if (!sh) build();
    shBtn = btn;
    /* recette-suite 22/10: translated sizes (« A3 (42 × 29,7 cm) ») say landscape by their numbers */
    var o0 = String(p.variants[0] && p.variants[0].option1 || ""), d0 = o0.match(/\(([\d.,]+)\s*[×x]\s*([\d.,]+)/);
    var land = /horizontal|paysage|landscape/i.test(o0) || (!!d0 && parseFloat(d0[1].replace(",", ".")) > parseFloat(d0[2].replace(",", ".")));
    var opts = p.variants.map(function (v) { return { v: v, f: fmtOf(v.option1) }; })
      .sort(function (a, b) { return ORDER.indexOf(a.f) - ORDER.indexOf(b.f); });
    $("[data-sh-fs]", sh).innerHTML = opts.map(function (o) {
      var own = String(o.v.option1 || "").match(/([\d.,]+)\s*×\s*([\d.,]+)\s*cm/);
      var d = DIM[o.f], dim = own ? esc(own[1] + " × " + own[2] + " cm") : d ? (land ? cm(d[1]) + " × " + cm(d[0]) : cm(d[0]) + " × " + cm(d[1])) + " cm" : esc(o.v.option1);
      var off = o.v.compare_at_price > o.v.price ? " <s>" + money(o.v.compare_at_price) + "</s>" : "";
      return '<button type="button" role="radio" class="cv2-sf" data-v="' + o.v.id + '"' + (o.v.available ? "" : " disabled") + '><b>' + esc(o.f || "") + "</b><span>" + dim + "</span><small>" + (o.v.available ? esc(USE[o.f] || "") : T("coll_v2_js.unavailable")) + "</small><em>" + money(o.v.price) + off + "</em></button>";
    }).join("");
    var want = curF || "A3", pick = null, first = null;
    opts.forEach(function (o) { if (!o.v.available) return; if (!first) first = o; if (o.f === want) pick = o; });
    pick = pick || first;
    st = { p: p, v: pick ? String(pick.v.id) : "", total: total || 0, img: btn.getAttribute("data-img") };
    var im = $("[data-sh-img]", sh); im.src = st.img || (p.featured_image || ""); im.hidden = !im.src;
    $("[data-sh-t]", sh).textContent = p.title;
    paint();
    sh.hidden = false; document.documentElement.style.overflow = "hidden";
    btn.setAttribute("aria-expanded", "true");
    var f = $(".cv2-sf.on", sh) || $("[data-sh-add]", sh); f.focus();
  };
  var close = function (focus) {
    if (!sh || sh.hidden) return;
    sh.hidden = true; document.documentElement.style.overflow = "";
    if (shBtn) { shBtn.setAttribute("aria-expanded", "false"); if (focus) shBtn.focus(); }
  };
  var add = function () {
    if (!st || !st.v || !(window.RV && RV.cart)) return;
    var b = $("[data-sh-add]", sh), f = "";
    st.p.variants.forEach(function (x) { if (String(x.id) === st.v) f = fmtOf(x.option1); });
    b.disabled = true; b.setAttribute("aria-busy", "true");
    RV.cart.add([{ id: Number(st.v), quantity: 1 }]).then(function () {
      close(false);
      if (RV.toast) RV.toast(T("coll_v2_js.added") + (f ? " · " + f : ""), st.img);
    }).catch(function () { if (RV.toast) RV.toast(T("coll_v2_js.add_failed")); })
      .then(function () { b.disabled = false; b.removeAttribute("aria-busy"); });
  };
  /* capture phase: on phones our sheet replaces the rv-v3 one for the cards of this page */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[data-rv-qa]");
    if (!btn || !coll.contains(btn) || !useSheet()) return;
    e.preventDefault(); e.stopImmediatePropagation();
    btn.setAttribute("aria-busy", "true");
    Promise.all([getP(btn.getAttribute("data-rv-qa")), cartTotal()]).then(function (r) {
      btn.removeAttribute("aria-busy"); open(btn, r[0], r[1]);
    }).catch(function () {
      btn.removeAttribute("aria-busy");
      var a = btn.closest(".wallcard"); location.href = (a && a.querySelector("a.wc-link") || {}).href || "/products/" + btn.getAttribute("data-rv-qa");
    });
  }, true);

  /* ---------- « Composez votre mur » (only rendered while packs_actifs is on) ---------- */
  var armPack = function (n) {
    var box = $("[data-cv2-pack]", n); if (!box) return;
    var fmt = "A3";
    var sel = function () { return $$(".cv2-pk-it", box).filter(function (b) { return b.getAttribute("aria-pressed") === "true"; }); };
    var vOf = function (b) { var hit = null; b.getAttribute("data-fv").split(",").forEach(function (e) { var p = e.split(":"); if (p[0] === fmt) hit = { id: Number(p[1]), price: Number(p[2]) }; }); return hit; };
    var upd = function () {
      var on = sel(), items = on.map(vOf).filter(Boolean), sum = 0;
      items.forEach(function (x) { sum += x.price; });
      var k = items.length, off = k >= 4 ? R4 : k >= 3 ? R3 : 0, tot = Math.round(sum * (100 - off) / 100);
      $("[data-pk-slots]", box).className = "cv2-pk-slots n" + on.length;
      $("[data-pk-slots]", box).innerHTML = on.map(function (b) { return '<img src="' + esc(b.getAttribute("data-a")) + '" alt="" loading="lazy">'; }).join("");
      $("[data-pk-n]", box).textContent = (window.RV && RV.plural ? RV.plural(k, "affiche") : k + " affiche" + (k > 1 ? "s" : "")) + " " + fmt;
      $("[data-pk-old]", box).textContent = off ? money(sum) : "";
      $("[data-pk-new]", box).textContent = money(tot);
      var o = $("[data-pk-off]", box); o.textContent = off ? T("coll_v2_js.pct_off", { n: off }) : ""; o.hidden = !off;
      $("[data-pk-ship]", box).textContent = (!FREE ? FROM() : tot >= FREE ? T("coll_v2_js.free_shipping") : T("coll_v2_js.ship_only_left", { amount: money(FREE - tot) })) + (k < 3 ? " · " + T("coll_v2_js.pack_more", { n: 3 - k, pct: R3 }) : k < 4 ? " · " + T("coll_v2_js.pack_one_more", { pct: R4 }) : "");
      var btn = $("[data-pk-btn]", box); btn.textContent = T("coll_v2_js.add_n", { n: k }); btn.disabled = !k;
    };
    box.addEventListener("click", function (e) {
      var it = e.target.closest(".cv2-pk-it"); if (it) { it.setAttribute("aria-pressed", String(it.getAttribute("aria-pressed") !== "true")); upd(); return; }
      var f = e.target.closest("[data-pk-f]"); if (f) { fmt = f.getAttribute("data-pk-f"); $$("[data-pk-f]", box).forEach(function (x) { x.setAttribute("aria-pressed", String(x === f)); }); upd(); return; }
      if (e.target.closest("[data-pk-btn]") && window.RV && RV.cart) {
        var items = sel().map(vOf).filter(Boolean).map(function (x) { return { id: x.id, quantity: 1 }; });
        if (items.length) RV.cart.add(items);
      }
    });
    upd();
  };
})();
